import { Endpoint } from '../types/api';

// Base configuration for different types of endpoints
export const BASE_ENDPOINTS = {
  // Static data files (current implementation)
  DATA: {
    baseURL: process.env.PUBLIC_URL || '',
    path: '/data',
  },

  // Future API endpoints
  API: {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://api.playmerce.com',
    path: '/api/v1',
  },

  // GraphQL endpoint (future)
  GRAPHQL: {
    baseURL: process.env.REACT_APP_GRAPHQL_URL || 'https://api.playmerce.com/graphql',
    path: '',
  },
} as const;

// Product data endpoints
export const PRODUCT_ENDPOINTS: Record<string, Endpoint> = {
  LILJA: {
    url: `${BASE_ENDPOINTS.DATA.baseURL}${BASE_ENDPOINTS.DATA.path}/product-data-lilja.json`,
    method: 'GET',
  },
  LAUKKUNI: {
    url: `${BASE_ENDPOINTS.DATA.baseURL}${BASE_ENDPOINTS.DATA.path}/product-data-laukkuni.json`,
    method: 'GET',
  },
  DEFAULT: {
    url: `${BASE_ENDPOINTS.DATA.baseURL}${BASE_ENDPOINTS.DATA.path}/product-data.json`,
    method: 'GET',
  },
  V2: {
    url: `${BASE_ENDPOINTS.DATA.baseURL}${BASE_ENDPOINTS.DATA.path}/product-data-2.json`,
    method: 'GET',
  },
} as const;

// Customer endpoints (Shopify app proxy)
export const CUSTOMER_ENDPOINTS: Record<string, Endpoint> = {
  SESSION: {
    url: '/apps/playmerce/session',
    method: 'GET',
  },
  EXPERIMENT: {
    url: '/apps/playmerce/experiment',
    method: 'GET',
  },
  SCROLL_COLLECT_STATUS: {
    url: '/apps/playmerce/scroll-and-collect',
    method: 'GET',
  },
  SCROLL_COLLECT_COMPLETE: {
    url: '/apps/playmerce/scroll-and-collect',
    method: 'POST',
  },
  SCROLL_COLLECT_SETTINGS: {
    url: '/apps/playmerce/scroll-and-collect/settings',
    method: 'GET',
  },
  SCROLL_COLLECT_ELIGIBLE: {
    url: '/apps/playmerce/scroll-and-collect/eligible',
    method: 'GET',
  },
  SCROLL_COLLECT_FEED: {
    url: '/apps/playmerce/scroll-and-collect/feed',
    method: 'GET',
  },
  SCROLL_COLLECT_PRODUCT: {
    url: '/apps/playmerce/scroll-and-collect/product',
    method: 'GET',
  },
  SCROLL_COLLECT_EVENT: {
    url: '/apps/playmerce/scroll-and-collect/event',
    method: 'POST',
  },
} as const;

// Shopify Admin endpoints
export const ADMIN_ENDPOINTS: Record<string, Endpoint> = {
  AUTH: {
    url: '/shopify/admin/auth',
    method: 'GET',
  },
} as const;
